import { useMutation } from '@tanstack/react-query'

import {
  FirstReceiptInfo,
  RefreshDigitalSignatureStatusClientRequest,
  RefreshDigitalSignatureStatusClientResponse,
} from '../../../@types/digitalSignature/RefreshDigitalSignatureStatus'
import { api } from '../../../Services/API'
import { useFirstReceiptInfo } from '../../../Stores/useFirstReceiptInfo'
import { useRefreshDigitalSignatureStatusStore } from '../../../Stores/useRefreshDigitalSignatureStatusStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { DIGITAL_STATUS } from '../../../constants/digitalStatus'

const request = async (payload: RefreshDigitalSignatureStatusClientRequest) => {
  const response = await api.post<RefreshDigitalSignatureStatusClientResponse>(
    API_ROUTES.refreshDigitalSignatureStatus,
    payload,
  )

  return response.data
}

export const useRefreshDigitalSignatureStatus = () => {
  const {
    setRefreshDigitalSignatureStatus,
    setIsSigned,
    setIsLoadingRefreshDigitalSignatureStatus,
  } = useRefreshDigitalSignatureStatusStore()
  const { setFirstReceiptInfo } = useFirstReceiptInfo()

  return useMutation({
    mutationFn: (payload: RefreshDigitalSignatureStatusClientRequest) =>
      request(payload!),
    onSuccess(data) {
      setRefreshDigitalSignatureStatus(data)
      setIsSigned(data?.digitalSignature?.status === DIGITAL_STATUS.SIG)
      setFirstReceiptInfo(data.firstReceiptInfo as FirstReceiptInfo)
      setIsLoadingRefreshDigitalSignatureStatus(false)
    },
    onError() {
      setIsLoadingRefreshDigitalSignatureStatus(false)
    },
  })
}
